<!DOCTYPE html>
<!-- saved from url=(0049)file:///Y:/Downloads/konnect%20waterv1/index.html -->
<html lang="en">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">

    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <title>Konnect Water Solution</title>

    <style>
        @media (min-width:600px) {
            .slide_m {
                display: block !important
            }

            .slide_s {
                display: none !important
            }

            .horizontal {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
            }

            .card2 {
                min-height: 300px;
                margin: 5px;
                font-size: 16px;
            }

            .logo {
                max-width: 200px !important;
            }

            .image_container {
                background-image: url('./assets/images/slider/s2.jpg');
            }
        }

        @media (max-width:600px) {
            .image_container {
                background-image: url('./assets/images/slider/s2_s.jpg');
            }

            .slide_m {
                display: none !important;
            }

            .slide_s {
                display: block !important;
            }

            .row {
                margin: 0px;
            }

            .carousel-inner {
                margin-top: 25px;
            }

            .horizontal::-webkit-scrollbar {
                display: none;
            }

            /* Hide scrollbar for IE, Edge and Firefox */
            .horizontal {
                -ms-overflow-style: none;
                /* IE and Edge */
                scrollbar-width: none;
                /* Firefox */
            }


            .horizontal {
                display: flex !important;
                flex-direction: row !important;
                overflow-x: scroll;
            }

            .card2 {
                min-width: 250px;
                font-size: 11px !important;
                margin: 2px;
                min-height: 280px !important;
            }

            .img2 {
                width: 50px !important;
                height: 50px !important
            }

            .title_card {
                font-size: 14px !important;
            }

            .title_card2 {
                font-size: 18px !important;
            }

            .container-xl {
                padding-left: 0px;
                padding-right: 0px
            }

            .big-padding {
                padding: 0px
            }

            .px-3 {
                padding: 0px !important
            }

            .container-lg {
                margin: 0px;
                padding: 0px;
            }

            .logo {
                max-width: 180px;
            }
        }

        .card3 {
            /* background-color: rgba(255,255,255,0.8); */
            min-height: 300px;
            border-radius: 10px;
            min-width: 350px;
            width: 100%;
            position: relative;
            max-width: 500px;
            padding: 15px;
            text-align: left;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 5px 0 rgba(0, 0, 0, .23);
        }

        .form-group {
            position: relative;
            margin-bottom: 1.5rem;
        }

        label {
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
            color: #999;
            transition: 0.2s ease all;
        }

        .form-control {
            border: none;
            border-radius: 0;
            border-bottom: 1px solid #ccc;
            padding: 0.5rem 0;
            background-color: transparent;
            transition: 0.2s ease all;
        }

        .line {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;

            background-color: #2196f3;
            transform: scaleX(0);
            transition: 0.2s ease transform;
        }

        .form-control:focus {
            outline: none;
            border-color: transparent;
        }

        .form-control:focus+.line {
            transform: scaleX(1);
        }

        .form-control:not(:placeholder-shown)+label {
            top: -1.5rem;
            font-size: 12px;
            margin-left: 10px;
            color: #2196f3;
        }

        .frost-overlay {
            position: relative;
        }

        .frost-overlay::before {
            content: "";
            position: absolute;
            border-radius: 10px;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(8px);
            z-index: 1;
        }

        .frost-overlay .content {
            position: relative;
            z-index: 2;
        }

        .custom-select {
            border: none;
            outline: none;
            box-shadow: none;
            background-color: rgba(173, 216, 230, 0.6);
            padding: 3px;
            font-weight: bold;
            /* color:darkgray; */
            font-size: 14px;
            border-radius: 3px;
        }
    </style>
</head>

<body class="bg-white">
    <header>
        <div id="menu-jk" class="nav-part shadow-md bg-white navcol">
            <div class="container-lg">
                <div class="row  p-2">
                    <div class="col-lg-3 p-2" style="display:flex;flex-direction:row;align-items:center">

                        <a href="index.html" style="max-width:200px">
                            <img class="'logo" src="assets/images/logo.png" alt="">
                        </a>
                        <div class='d-lg-none'
                            style="flex:1;font-size:13px;padding-right:0px;display:flex;flex-direction:column;justify-content:center;align-items:flex-end;">
                            <div>Contact us</div>
                            <div style="font-weight:bold;">0701888666</div>

                        </div>

                        <!-- <a class="float-end d-lg-none pt-1 ps-3"><i class="bi pt-1 fs-1 cp  bi-telephone"></i></a> -->
                    </div>

                    <div id="menu" class="col-lg-9 d-none pt-1 d-lg-block"
                        style="display:flex;flex-direction:row;align-items:center">

                        <div
                            style="flex:1;padding-right:20px;display:flex;flex-direction:column;justify-content:center;align-items:flex-end;">
                            <div class="d-none pt-1 d-lg-block">Contact us</div>
                            <div class="d-none pt-1 d-lg-block" style="font-weight:bold">0701888666</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </header>
    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="true">

        <div class="carousel-inner">

            <div class="image_container" style="width: 100%;display: flex;justify-content: center;flex-direction: row;padding-top: 10px;padding-bottom: 20px; background-repeat: no-repeat;
            background-size: cover;
            background-position: center;">

                <div style="text-align: center;padding:10px">
                    <h2 class="fs-7 fw-bolder mt-4 title_card" style="font-weight: bold;">Get Reliable Water Solution
                        with Konnect</h2>

                    <div class=" form-group ">
                        <div class="frost-overlay card3">
                            <div class="content ">
                                <img class="'logo" src="assets/images/lipa.png" height="35px" alt="">
                                <br />
                                <div
                                    style="width:90%;text-align: right;display:flex;flex-direction: row;justify-content: flex-end;">
                                    <div>
                                        <div><small style="font-weight: bold;">Select volume</small></div>
                                        <div>
                                            <!-- <select class="form-select">
                                                <option value="500ml_9">500 ML - 9/=</option>
                                                <option value="1l_15">1 Litres - 15/=</option>
                                                <option value="5l_35">5 Litres - 35/=</option>
                                            </select> -->
                                            <mat-select [(value)]="selected" class="form-select"
                                                hideSingleSelectionIndicator="true" style="background-image:none;width: 110%;">
                                                <mat-option value="8">500 ML - 8/=</mat-option>
                                                <mat-option value="15">1 Litres - 15/=</mat-option>
                                                <mat-option value="35">5 Litres - 35/=</mat-option>
                                                <mat-option value="65">10 Litres - 65/=</mat-option>
                                                <mat-option value="120">20 Litres - 120/=</mat-option>
                                            </mat-select>

                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div><strong>Enter phone number</strong></div>
                                <div style="display:flex;flex-direction: row;">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">+254 </span>
                                    </div>
                                    <div style="flex:1">
                                        <div class="form-group" style="width: 90%;">

                                            <input matInput [(ngModel)]="phone" type="tel" maxlength="9" class="form-control" id="phone"
                                                placeholder="Phone number" style="padding-left: 0px;margin-left: 10px;" required>
                                            <div class="line" style="padding-left: 0px;margin-left: 10px;"></div>
                                        </div>
                                    </div>

                                </div>
                                <button (click)="payRequest()" class="btn btn-primary" style="width:100%;">Buy Now</button>
                                <br /> <br />
                                <p> Konnect is dedicated to providing affordable clean water solutions for every
                                    household.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div id="blog" class="service container-fluid  bg-white " style="margin-top:20px">
                <div class="container-xl">
                    <div class="section-title row mb-3" style="margin: 0px !important;">
                        <h2 class="fw-bolder">Our Gallery</h2>
                    </div>
                    <div class="horizontal">
                        <div class="col-lg-4 col-md-6 mb-4">
                            <div class="serv-cove rounded bg-white p-2 card2">
                                <img src="assets/images/blog/p1.jpg" alt="">
                                <div class="p-2">
                                    <h5 class="mt-3 fs-7 fw-bold">Our partnership with Iclear makes this water solution
                                        possible</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4">
                            <div class="serv-cove rounded bg-white p-2 card2">
                                <img src="assets/images/blog/p2.jpg" alt="">
                                <div class="p-2">
                                    <h5 class="mt-3 fs-7 fw-bold">We use state of the art technology to bring clean and
                                        purified water to you.</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 mb-4">
                            <div class="serv-cove rounded bg-white p-2 card2">
                                <img src="assets/images/blog/p3.jpg" alt="">
                                <div class="p-2">
                                    <h5 class="mt-3 fs-7 fw-bold">Choose the best water solution for you and your family
                                    </h5>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <footer>
                <div class="inner">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6 ">
                                <h5>About us</h5>
                                <p style="font-size:12px;">At Konnect, we are passionate about providing convenient and
                                    sustainable drinking water solutions.</p>
                                <p style="font-size:12px;">With our state-of-the-art water purification and dispensing
                                    machines, users can refill their reusable bottles on the go, saving money and
                                    reducing their environmental impact. We strive to make clean drinking water
                                    accessible to everyone while promoting sustainability and reducing plastic
                                    pollution.</p>

                                <p style="font-size:12px;">Join us in our mission to create a greener and healthier
                                    future by choosing the Konnect Water Solution for your hydration needs.</p>
                            </div>
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3"> <br />
                                <h5>Contact Us</h5>
                                <address>
                                    Zimmerman, Roysambu<br>
                                    Kasarani, Nairobi<br>
                                    Kenya<br>
                                    <br>
                                    Phone: +254701888666
                                </address>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col text-center">
                                <p>&copy; 2023 Konnect Water Solution. All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</body>

</html>